__turbopack_context__.v({
  "wrapper": "price-wrapper-module__Wn0hNa__wrapper",
});
